import { Hub } from '@sentry/browser';
import { HttpClient } from '@sentry/integrations';
import { debugMessage } from '../debugMessage';

export class S4MPHttpClient {
  public static id: string = 'S4MPHttpClient';
  public name: string = S4MPHttpClient.id;
  private _hub: Hub;
  options: ConstructorParameters<typeof HttpClient>[0];

  constructor(
    hub: Hub,
    httpOptions: ConstructorParameters<typeof HttpClient>[0],
  ) {
    this._hub = hub;
    this.options = httpOptions;
  }

  setupOnce() {
    debugMessage('sentry: setting up S4MPHttpClient integration');
    new HttpClient(this.options).setupOnce(
      () => {},
      () => this._hub,
    );
  }
}
